// theme.js
export const theme = {
    primaryDark: '#FFDF3E',
    primaryLight: 'black',
    primaryHover: '#343078',
    mobile: '576px',
  }